import { useLayoutEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { logOut, setCredentials, setIsAuth, setIsAuthLoading } from '@reducers/authSlice';
import { setActiveRole, setUser } from '@reducers/userSlice';
import { useAuthUserMutation } from '@api/editorApi/AuthApi/AuthSerivce.js';
import { useLazyGetEditorViewQuery } from '@api/editorApi/UserApi/UserService.js';

export const useAuth = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [authUser] = useAuthUserMutation();
    const [getUserInfo] = useLazyGetEditorViewQuery();
    const isAuth = useSelector((state) => state.auth.isAuth);
    const storedUser = JSON.parse(localStorage.getItem('user'));
    const [isLoading,setIsLoading] = useState((!!storedUser && !isAuth));

    useLayoutEffect(() => {
        const refresh_token = JSON.parse(localStorage.getItem('jwt_refresh'));

        const authenticate = async () => {
            if (storedUser?.email && refresh_token) {

                const result = await authUser({
                    username: storedUser.email,
                    grant_type: 'refresh_token',
                    refresh_token
                });
                if (result.error) {
                    console.error(result.error);
                    // Разлогиниваем только при явном отказе сервера (401/400),
                    // при сетевой ошибке (status === 'FETCH_ERROR') сессию не трогаем
                    const status = result.error?.status;
                    if (status === 401 || status === 400) {
                        navigate('/');
                        localStorage.clear();
                    }
                    return;
                }
                dispatch(setCredentials(result.data.access_token))
                dispatch(setActiveRole(storedUser.activeRole));
                dispatch(setIsAuth(true));
                localStorage.setItem('jwt_refresh', JSON.stringify(result.data.refresh_token));

                const user = await getUserInfo();
                if (user.error) {
                    console.error(user.error);
                    return;
                }

                dispatch(setUser({ ...storedUser }));

                const activeRole = user.data.roles.includes(storedUser.activeRole)
                  ? storedUser.activeRole
                  : user.data.roles[0];
                dispatch(setActiveRole(activeRole));

                localStorage.setItem('user', JSON.stringify({ ...storedUser, activeRole }));
                dispatch(setIsAuthLoading(false));
            } else if (!storedUser?.email) {
                dispatch(setIsAuthLoading(false));
                dispatch(logOut());
            }

        };
        if (storedUser?.email && !isAuth) {
            authenticate().finally(()=> setIsLoading(false));
        }
    }, []);

    return isLoading
};
